import {
  AppBar,
  Slide,
  Toolbar,
  Typography,
  useScrollTrigger,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getEvents } from 'app/slices/Event'
import { getOrganizer } from 'app/slices/Organizer'
import {
  getAuth,
  getPrefectures,
  // getSurveys,
  getTemplates,
} from 'app/slices/UI'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import TemporaryMenu from './TemporaryMenu'

interface Props {
  window?: () => Window
  children: React.ReactElement
}
function HideOnScroll(props: Props) {
  const { children, window } = props
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  })

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}
export default function AppHeader(props: Props) {
  const auth = useAppSelector((s) => s.UI.auth)
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(getAuth())
    dispatch(getPrefectures())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (auth) {
      dispatch(getEvents())
      // dispatch(getSurveys())
      dispatch(getTemplates())
      dispatch(getOrganizer(auth.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth])

  return (
    <HideOnScroll {...props}>
      <AppBar>
        <Toolbar className="flex justify-between items-center">
          <Link to={'/'} className="no-underline">
            <Typography className="system-name" variant="h5" component="h1">
              <span>なぞしゅう</span> - オーナー管理
            </Typography>
          </Link>
          {auth && (
            <>
              <TemporaryMenu auth={auth} />
            </>
          )}
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  )
}
